// Singleton Comlink-wrapped worker proxy. The worker is spawned once
// per page load; every consumer imports this hook. On lock, callers
// drop their `handle` — the worker itself stays alive.

import * as Comlink from "comlink";
import type { VaultWorkerApi } from "../worker/api";
import { registerVaultStreamSw } from "../lib/swRegistration";

let proxy: Comlink.Remote<VaultWorkerApi> | null = null;

function getProxy(): Comlink.Remote<VaultWorkerApi> {
  if (proxy) return proxy;
  const worker = new Worker(
    new URL("../worker/vault.worker.ts", import.meta.url),
    { type: "module" },
  );
  proxy = Comlink.wrap<VaultWorkerApi>(worker);
  void registerVaultStreamSw(proxy);
  return proxy;
}

export function useVault(): Comlink.Remote<VaultWorkerApi> {
  return getProxy();
}
